// Full product list desktop
import {SKELETON_SLIDER, SKELETON_SLIDER_MOBILE} from 'Component/ProductListWidget/ProductListWidget.config';
export const SKELETON_PLP_CARD_DETAILS = [
    {
        type: 'group',
        flexDirection: 'column',
        alignItems: 'flex-start',
        items: [
            {
                type: 'rect', width: '180px', height: '14px', className: 'mb-0.5'
            },
            {
                type: 'rect', width: '100%', height: '16px', className: 'mb-1'
            },
            {
                type: 'rect', width: '60px', height: '20px', className: 'mb-3'
            },
            {
                type: 'rect', width: '100%', height: '24px', className: ''
            }
        ]
    }
];

export const LAYOUT_TOP_CATEGORY_FULL = [
    {
        type: 'group',
        className: 'relative',
        items: [
            {
                type: 'rect',
                width: '100%',
                className: 'lg:h-[216px] h-[234px] w-screen! mx-[calc(-50vw+50%)]'
            }
        ]
    }
];

export const FILTERS_SKELETON_DESKTOP = [
    {
        type: 'group',
        gap: 8,
        className: 'flex flex-wrap max-w-1400! lg:py-4 lg:mx-auto ',
        columns: 3,
        items: [
            {
                type: 'rect',
                width: '126px',
                height: '44px'
            }
        ]
    }
];

export const SKELETON_PLP = [
    {
        type: 'group',
        columns: 24,
        flexDirection: 'row',
        className: 'pb-2 lg:grid! lg:grid-cols-[repeat(4,1fr)] lg:max-w-1400! mx-auto gap-x-4! gap-y-12! mb-12!',
        items: [
            {
                type: 'group',
                flexDirection: 'column',
                alignItems: 'flex-start',
                items: [
                    {
                        type: 'rect', width: '100%', className: 'aspect-4/5 mb-3'
                    },
                    ...SKELETON_PLP_CARD_DETAILS
                ]
            }
        ]
    }
];

export const LAYOUT_PRODUCT_LIST = [
    ...LAYOUT_TOP_CATEGORY_FULL,
    ...FILTERS_SKELETON_DESKTOP,
    ...SKELETON_PLP
];

// Full product list mobile

export const SKELETON_PLP_CARD_DETAILS_MOBILE = [
    {
        type: 'group',
        flexDirection: 'column',
        alignItems: 'flex-start',
        items: [
            {
                type: 'rect', width: '180px', height: '14px', className: 'mb-0.5'
            },
            {
                type: 'rect', width: '100%', height: '16px', className: 'mb-1'
            },
            {
                type: 'rect', width: '60px', height: '20px', className: 'mb-3'
            },
            {
                type: 'rect', width: '100%', height: '24px', className: ''
            }
        ]
    }
];

export const MOBILE_CATEGORY_DETAILS = [
    {
        type: 'group',
        className: 'flex!',
        flexDirection: 'column',
        alignItems: 'flex-start',
        items: [
            {
                type: 'group',
                alignItems: 'flex-start',
                className: 'px-4 ',
                flexDirection: 'column',
                items: [
                    { type: 'rect', className: 'max-w-[280px] w-full mb-0.5', height: '30px' },
                    { type: 'rect', className: 'max-w-[380px] w-full mb-1', height: '20px' },
                    { type: 'rect', className: 'max-w-[300px] w-full mb-[20px]', height: '20px' }
                ]
            },
            {
                type: 'rect',
                className: 'flex aspect-5/3 w-full'
            }
        ]
    }
];

export const FILTERS_SKELETON_MOBILE = [
    {
        type: 'group',
        className: 'flex flex-col! pt-2 px-4',
        items: [
            {
                type: 'rect',
                width: '100%',
                height: '44px',
                className: 'mb-3'
            },
            {
                type: 'rect',
                width: '200px',
                height: '20px',
                className: 'mb-2 self-start'
            }
        ]
    }
];

export const SKELETON_PLP_MOBILE = [
    {
        type: 'group',
        columns: 24,
        flexDirection: 'column',
        className: ' pb-2 grid! px-4 gap-y-6! gap-x-2! mb-6 grid-cols-[1fr_1fr] md:grid-cols-[repeat(3,1fr)]',
        items: [
            {
                type: 'group',
                flexDirection: 'column',
                alignItems: 'flex-start',
                className: 'pb-2',
                items: [
                    {
                        type: 'rect', width: '100%', className: 'aspect-[3/3.7] mb-3'
                    },
                    ...SKELETON_PLP_CARD_DETAILS_MOBILE
                ]

            }
        ]
    }
];

export const MOBILE_SLIDER_SKELETON = [
    {
        type: 'group',
        flexDirection: 'column',
        className: 'py-6',
        gap: 24,
        items: [
            {
                type: 'group',
                flexDirection: 'column',
                alignItems: 'left',
                className: 'px-4',
                items: [
                    {height: '27px', width: '200px', className: '' },
                    {height: '23px', width: '200px', className: 'mt-1' }
                ]
            },
            ...SKELETON_SLIDER_MOBILE
        ]
    }
]

export const DESKTOP_SLIDER_SKELETON = [
    {
        type: 'group',
        flexDirection: 'column',
        className: 'py-6',
        gap: 24,
        items: [
            {
                type: 'group',
                flexDirection: 'column',
                alignItems: 'left',
                items: [
                    {height: '34px', width: '200px', className: '' },
                    {height: '24px', width: '200px', className: 'mt-1' }
                ]
            },
            ...SKELETON_SLIDER
        ]
    }
]

export const LAYOUT_PRODUCT_LIST_MOBILE = [
    ...MOBILE_CATEGORY_DETAILS,
    ...FILTERS_SKELETON_MOBILE,
    ...SKELETON_PLP_MOBILE
];

// Product Wishlist Button skeleton

export const PRODUCT_WISHLIST_BUTTON = [
     {
        type: 'group',
        className: 'relative',
        items: [
            {
                className: 'h-4! w-4!'
            }
        ]
    }
];

export const ITEMS_COUNT_SKELETON = [
    {
        width: '200px',
        height: '20px',
        className: 'my-auto flex flex-start ml-4 mb-4 lg:mb-0 lg:ml-auto lg:justify-end'
    }
]